var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"yz-dot",class:{ 'yz-dot--primary': _vm.color === 'primary' },style:(_vm.dotStyle)})}
var staticRenderFns = []

export { render, staticRenderFns }